import { CSSProperties, memo } from 'react';
import { createUseStyles } from 'react-jss';
import cn from 'classnames';

type TitleProps = {
  className?: string,
  style?: CSSProperties
};

const Title = (props: TitleProps) => {
  const {
    className,
    style,
  } = props;
  const classes = useStyles();
  return (
    <div
      className={cn(classes.componentPageGiftTitle, className)}
      style={style}
    >
      Rewards Card
    </div>
  );
};

const useStyles = createUseStyles({
  componentPageGiftTitle: {
    fontSize: '1.6rem',
    textAlign: 'center',
  },
});

export default memo(Title);
